/**
 * ## Button Slice
 * 
 * @category Slice
 * @module Button Slice
 */
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit';

interface IBlockedState {
	isButtonBlocked: boolean;
}

const initialState: IBlockedState = {
	isButtonBlocked: false
}

const buttonSlice = createSlice({
	name: "button",
	initialState,
	reducers: {
		setIsButtonBlocked: (state, action: PayloadAction<boolean>) => {
			state.isButtonBlocked = action.payload;
		}
	}
});

export const { setIsButtonBlocked } = buttonSlice.actions;

export default buttonSlice.reducer;
